<div
  class="origin"
  cdkOverlayOrigin
  #filtersOrigin="cdkOverlayOrigin"
></div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="filtersOrigin"
  [cdkConnectedOverlayOpen]="!!filters"
  [cdkConnectedOverlayPush]="false"
  [cdkConnectedOverlayViewportMargin]="20"
  [cdkConnectedOverlayPositions]="overlayPositionsOuter"
>
  <div
    class="filters-menu"
  >
    <div class="title">
      Filters
    </div>

    @if (filtersConfig.by.devices) {
      <div class="row">
        <div
          class="toggle-col"
        >
          <motn-toggle-input-wrapper
            (click)="onClickDeviceToggle()"
            [color]="'flat-blue_gray-indigo'"
          >
            <input
              type="checkbox"
              [(ngModel)]="deviceFilterToggled"
              #checkboxEl
            >
          </motn-toggle-input-wrapper>
        </div>

        <div
          class="name-col"
        >
          Devices

          <span
            (click)="toggleDeviceMenu()"
          >
            <i
              class="fa-solid fa-circle-chevron-down"
            ></i>
          </span>
        </div>

        @if (deviceMenuOpen) {
          <motn-popover-select-devices
            [preselectedDevices]="filters.devices"
            [overlayPositions]="overlayPositionsInner"
            (clickedOption$)="onClickDeviceOption($event)"
            (clickedOutsideMenu$)="closeDeviceMenu()"
          ></motn-popover-select-devices>
        }
      </div>
    }

    @if (filtersConfig.by.hubs) {
      <div class="row">
        <div
          class="toggle-col"
        >
          <motn-toggle-input-wrapper
            (click)="onClickHubToggle()"
            [color]="'flat-blue_gray-indigo'"
          >
            <input
              type="checkbox"
              [(ngModel)]="hubFilterToggled"
              #checkboxEl
            >
          </motn-toggle-input-wrapper>
        </div>

        <div
          class="name-col"
        >
          Hubs

          <span
            (click)="toggleHubMenu()"
          >
            <i
              class="fa-solid fa-circle-chevron-down"
            ></i>
          </span>
        </div>

        @if (hubMenuOpen) {
          <motn-popover-select-hubs
            [preselectedHubs]="filters.hubs"
            [overlayPositions]="overlayPositionsInner"
            (clickedOption$)="onClickHubOption($event)"
            (clickedOutsideMenu$)="closeHubMenu()"
          ></motn-popover-select-hubs>
        }
      </div>
    }

    @if (filtersConfig.by.owners) {
      <div class="row">
        <div
          class="toggle-col"
        >
          <motn-toggle-input-wrapper
            (click)="onClickOwnerToggle()"
            [color]="'flat-blue_gray-indigo'"
          >
            <input
              type="checkbox"
              [(ngModel)]="ownerFilterToggled"
              #checkboxEl
            >
          </motn-toggle-input-wrapper>
        </div>

        <div
          class="name-col"
        >
          Only owned by me
        </div>
      </div>
    }

    @if (filtersConfig.by.metadata) {
      <div class="row">
        <div
          class="toggle-col"
        >
          <motn-toggle-input-wrapper
            (click)="onClickMetadataToggle()"
            [color]="'flat-blue_gray-indigo'"
          >
            <input
              type="checkbox"
              [(ngModel)]="metadataSearchToggled"
              #checkboxEl
            >
          </motn-toggle-input-wrapper>
        </div>

        <div
          class="name-col"
        >
          Include metadata
        </div>
      </div>
    }
  </div>
</ng-template>
